<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <div v-show='(searchType!="keyword")'>
            <h2 v-if='(searchType!=="alltags" && searchType!=="mytags" && searchType!=="mylikes" && searchType!=="alllikes")'>{{searchPrompt}}</h2>
            <h2 v-if='(searchType==="alltags" || (searchType==="mytags" && isAuthenticated))'>Drafts <b-form-select v-if='this.isAuthenticated' style='width: auto' class="form-control input-larger-text" v-model="searchType" :options='tagsSearchTypeOptions' @change='setSearchType'/> tagged as: <span class='bold-prompt'>{{tagName}}</span></h2>
            <h2 v-if='(searchType==="alllikes" || (searchType==="mylikes" && isAuthenticated))'>Drafts Liked by <span v-if='(!this.isAuthenticated)'>Anyone</span><b-form-select v-if='this.isAuthenticated' style='width: auto' class="form-control input-larger-text" v-model="searchType" :options='likesSearchTypeOptions' @change='setSearchType'/></h2>

            <div v-if='(searchType==="threading")'>These drafts <span class='bold'>or their straightened/turned/point variants</span> can be woven on the same warp threading<span v-if='patternId===0'>:</span>
                <span v-if='patternId > 0'>as <a :href='this.draftDetailUrl'>#{{this.patternId}}</a>{{this.threadingSearchSubPrompt}}.</span>
                <div class='top-padding' v-if='isSubscriber'>
                    <table v-if='isSubscriber && sampleDraft' ref='drawdown-table'>
                        <tr>
                            <td :style='getTableCellStyles(false, false)'>
                                <ruler :itemsCount='sampleDraft.WarpThreadsCount' startingSide='right' :cellPixelSize = 'cellPixelSize' 
                                :lineThicknessPixels='borderThicknessPixels' />
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td :style='getTableCellStyles(false, false)'>
                                <!-- threading -->
                                <grid uniqueCanvasId='threadingGrid + drawdownRenderingKey' :rowsCount='sampleDraft.ShaftsCount'
                                :columnsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize' 
                                :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" 
                                cellNotSelectedColor="#ffffff" :rowMajorArray="threading" :singleColumnSelection='false' :singleRowSelection='true' 
                                :isReadOnly='true' :showInverse='false' :renderingKey='threadingRenderingKey'/>
                            </td>
                            <td :style='getTableCellStyles(false, false)'><ruler :itemsCount='sampleDraft.ShaftsCount' startingSide='bottom' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                        </tr>              
                    </table>
                </div>
            </div>
        </div>

        <div v-show='(collectionDescription && collectionDescription.length > 0)'>
            <span v-html='collectionDescription'/>
            <span v-show='collectionOriginalSourceLinkUrl && collectionOriginalSourceLinkUrl.length > 0'>
                <a target='_blank' :href='collectionOriginalSourceLinkUrl'>{{collectionOriginalSourceLinkText}}</a>
                <br />
            </span>
            <hr/>
        </div>

        <div v-if='((this.searchType==="clipboard") && totalResults && (totalResults > 0))'>
            <b-button variant='default' @click="showClearBoardDialog">Clear Clipboard</b-button>
        </div>

        <div v-if='(this.searchType=="board") && this.boardNotFound'>
            Board not found: <a href='/board-search?page=0'>Choose another board</a>
        </div>

        <div v-if='(this.userIsBoardOwner && (this.searchType==="board") && totalResults && (totalResults > 0))'>
            <b-button variant='default' @click="showClearBoardDialog">Clear Board</b-button>
        </div>

        <div v-if='(searchType=="clipboard" && !isAuthenticated)'>
            Please sign in to view your draft clipboard.
            <login-control prompt="Sign In Now" :show-as-link="false"/>
        </div>

        <div v-if='(searchType=="mytags" && !isAuthenticated)'>
            Please sign in to view your tagged drafts.
            <login-control prompt="Sign In Now" :show-as-link="false"/>
        </div>

        <div v-if='(searchType=="mylikes" && !isAuthenticated)'>
            Please sign in to view your liked drafts.
            <login-control prompt="Sign In Now" :show-as-link="false"/>
        </div>        

        <b-row v-if="!authRequiredAndMissing()">
            <b-col v-if='(searchType==="collection")' sm='7' class="small-top-padding">
                Collection:<br />
                <b-form-select class="form-control" v-model="selectedCollectionId" :options='collectionOptions' @change='setSelectedCollectionOrCategory'/>
            </b-col>
            <b-col v-if='(searchType==="category")' sm='7' class="small-top-padding">
                Category:<br />
                <b-form-select v-model="selectedCategoryId" :options='categoryOptions' @change='setSelectedCollectionOrCategory'/>
            </b-col>
            <b-col v-if='(searchType==="keyword")' sm='7' class="small-top-padding">
                Enter Optional Keyword or Draft ID:<br />
                <b-input-group>
                    <b-form-input type="text" v-model='keyword' @input='debounceKeywordInput'/>
                    <b-input-group-append>
                        <b-btn variant='primary' @click='loadDraftsForKeyword' type="button">Search</b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col v-if='!boardNotFound' class="small-top-padding">
                <div v-if='searchType !== "threading"' class='inline-auto-width small-horizontal-padding'>
                    Min&nbsp;Shafts:<br />
                    <b-form-select v-model="minShafts" :options='minShaftsOptions' @change='setMinShafts' />
                </div>
                <div v-if='searchType !== "threading"' class='inline-auto-width small-horizontal-padding'>
                Max&nbsp;Shafts:<br />
                <b-form-select v-model="maxShafts" :options='maxShaftsOptions' @change='setMaxShafts' />
                </div>
                <div class='inline-auto-width small-horizontal-padding'>                
                    Max&nbsp;Treadles:<br />
                    <b-form-select v-model="maxTreadles" :options='maxTreadlesOptions' @change='setMaxTreadles' />
                </div>
                <div class='inline-auto-width small-horizontal-padding'>                
                    Max&nbsp;Float:<br />
                    <b-form-select v-model="maxFloatLength" :options='maxFloatLengthOptions' @change='setMaxFloatLength' />
                </div>
                <a v-if='(this.minShafts > 0 || this.maxShafts > 0 || this.maxTreadles > 0 || this.maxFloatLength > 0)' href='#' @click='clearAllFilters'>Clear&nbsp;Filters</a>
            </b-col>
        </b-row>

        <div class="top-padding" v-if='(searchType==="surprise")'>
            <b-button variant='default' v-if='searchType==="surprise"' @click="initializeComponent">Show More Random Drafts &raquo;</b-button>
        </div>

        <draft-search-results v-if='!authRequiredAndMissing() && !boardNotFound' v-show='resultsVisible()' 
        :show-share-button='this.searchType!=="clipboard" && this.searchType!=="mytags" && this.searchType!=="mylikes"' 
        :patterns='patternsArray' :items-per-page='itemsPerPage' :current-page-number="this.initialPageNum" 
        :total-results='totalResults' :on-go-to-page="this.goToPage" :show-board-links="this.userIsBoardOwner" 
        :on-remove-from-board="this.removeFromBoard"
        @thumbnailSizeChanged='onThumbnailSizeChanged' />

        <div v-if='(searchType==="surprise")'>
            <b-button variant='default' v-if='searchType==="surprise"' @click="initializeComponent">Show More Random Drafts &raquo;</b-button>
        </div>

        <div class="top-padding" v-if='(searchType=="category")'>
            <h4>Searching for Drafts by Category</h4>
            While we allow searching by category, most of the drafts on this site are not yet categorized and the list
            of categories needs revision.
        </div>

        <related-store-products :collectionId='selectedCollectionId' v-if='(searchType==="collection")'></related-store-products>

        <help-us-button/>
        <mail-chimp-signup/>
        <b-modal auto-focus-button='cancel' ref='boardClearModalRef' title='Clear Board?' ok-title='Clear Board »' @ok='handleClearBoard' cancel-title='Cancel' @cancel='handleClearBoardCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Would you like to remove all the entries on your <span v-if='searchType==="clipboard"'>draft clipboard?</span><span v-if='searchType!=="clipboard"'>{{board ? board.Title : ''}} draft board?</span>
            </div>
        </b-modal>

    </b-container>
</template>

<script>
/* eslint-disable handle-callback-err */
import dataService from '../mixins/dataService.js'
import urlsService from '../mixins/urlsService'
import utilityService from '../mixins/utilityService'
import draftEditorService from '../mixins/draftEditorService'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import draftSearchResults from './DraftSearchResults.vue'
import relatedStoreProducts from './RelatedStoreProducts'
import loginControl from './LoginControl.vue'
import ruler from './Ruler.vue'
import grid from './Grid.vue'
import cfg from '../config/config.js'

export default {
    mixins: [dataService, urlsService, utilityService, draftEditorService],
    data() {
        return {
            searchPrompt: '',
            threadingSearchSubPrompt: '',
            keyword: '',
            selectedCollectionId: -1,
            selectedCategoryId: -1,
            collectionOptions: [],
            categoryOptions: [],
            collectionDescription: '',
            collectionOriginalSourceLinkUrl: '',
            collectionOriginalSourceLinkText: '',
            itemsPerPage: 0,
            initialPageNum: 0,
            patternsArray: [],
            totalResults: 0,
            minShafts: 0,
            maxShafts: 0,
            maxTreadles: 0,
            maxFloatLength: 0,
            patternId: 0,
            isTurned: false,
            isStraightened: false,
            isPointed: false,
            draftDetailUrl: '#',
            initialPageLoad: true,
            tagName: '',
            searchType: '',
            tagsSearchTypeOptions: [{ text: 'You', value: 'mytags' }, { text: 'Anyone', value: 'alltags' }],
            likesSearchTypeOptions: [{ text: 'You', value: 'mylikes' }, { text: 'Anyone', value: 'alllikes' }],
            boardId: 0,
            board: { BoardID: 0, Title: 'Clipboard', PatternsCount: 0, OwnerName: '' },
            boardNotFound: false,
            gridBorderColor: '#acacac',
            thumbnailSize: 4,
            borderThicknessPixels: 1,
            sampleDraft: { WarpThreadsCount: 1, ShaftsCount: 1 },
            threading: [ false ],
            threadingRenderingKey: '777',
            threadingHash: 0
        }
    },
    methods: {

        generateNumericOptionsList(defaultPrompt, defaultValue, numericValuesArray) {
            let options = []
            options.push({ text: defaultPrompt, value: defaultValue })
            for (let c=0; c<numericValuesArray.length; c++) {
                let val = numericValuesArray[c]
                options.push({ text: val + '', value: val })
            }
            return options
        },

        getCurrentCollectionOption() {
            return this.collectionOptions.find(c => c.value === this.selectedCollectionId)
        },

        getCurrentCategoryOption() {
            return this.categoryOptions.find(c => c.value === this.selectedCategoryId)
        },

        goToPage(pageNumber) {
            let q = this.getCurrentQuerystringCopy()  // vue router won't pick up changes to the original object; a copy must be made
            q.page = pageNumber + ''
            this.$router.replace({ query: q }).catch(err => {})
            this.initializeComponent()
        },

        authRequiredAndMissing() {
            if (this.searchType==='mytags' || this.searchType==='mylikes' || this.searchType==='clipboard') {
                return !this.isAuthenticated
            }
            else {
                return false
            }
        },

        removeFromBoard(patternId) {
            if (this.searchType==='clipboard') {
                this.deleteClipboardPattern(this.authUser.UserID, patternId, this.authUser.LoginToken).then(resp => {
                    this.initializeComponent()
                })
            }
            else if (this.searchType==='board' && this.userIsBoardOwner) {
                this.deleteUserBoardPattern(this.board.BoardID, patternId, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                    this.initializeComponent()
                })
            }
        },

        setMinShafts(s) {
            this.minShafts = s // NOTE: This is needed due to a timing problem, where the onchange event is triggered prior to the bound variable actually changing, the new value is passed as the sole parameter, s in this case
            this.setQuerystringValue('minshafts', s)
            this.setQuerystringValue('page', 0)
            this.saveAllFiltersUserSettings()
            this.initializeComponent()
        },

        setMaxShafts(s) {
            this.maxShafts = s // NOTE: This is needed due to a timing problem, where the onchange event is triggered prior to the bound variable actually changing, the new value is passed as the sole parameter, s in this case
            this.setQuerystringValue('maxshafts', s)
            this.setQuerystringValue('page', 0)
            this.saveAllFiltersUserSettings()
            this.initializeComponent()
        },

        setMaxTreadles(t) {
            this.maxTreadles = t // NOTE: This is needed due to a timing problem, where the onchange event is triggered prior to the bound variable actually changing, the new value is passed as the sole parameter, t in this case
            this.setQuerystringValue('maxtreadles', t)
            this.setQuerystringValue('page', 0)
            this.saveAllFiltersUserSettings()
            this.initializeComponent()
        },

        setMaxFloatLength(f) {
            this.maxFloatLength = f // NOTE: This is needed due to a timing problem, where the onchange event is triggered prior to the bound variable actually changing, the new value is passed as the sole parameter, t in this case
            this.setQuerystringValue('maxfloatlength', f)
            this.setQuerystringValue('page', 0)
            this.saveAllFiltersUserSettings()
            this.initializeComponent()
        },

        setQuerystringValue(propertyName, propertyValue) {
            let q = this.getCurrentQuerystringCopy()  // vue router won't pick up changes to the original object; a copy must be made
            q[propertyName] = propertyValue + ''
            this.$router.replace({ query: q }).catch(err => {})
        },

        setSearchType() {
            if (this.searchType !== this.$route.params.searchType) {
                this.$route.params.searchType = this.searchType // tags and likes dropdowns allow search type change
                this.$router.replace({ params: { searchType: this.searchType } }).catch(err => {})
                this.initializeComponent()
            }
        },

        clearAllFilters() {
            let q = this.getCurrentQuerystringCopy()  // vue router won't pick up changes to the original object; a copy must be made
            this.minShafts = 0
            q.minshafts = 0
            this.maxShafts = 0
            q.maxshafts = 0
            this.maxTreadles = 0
            q.maxtreadles = '0'
            this.maxFloatLength = 0
            q.maxfloatlength = '0'
            q.page = '0'
            this.$router.replace({ query: q }).catch(err => {})
            this.saveAllFiltersUserSettings()
            this.initializeComponent()
        },

        saveAllFiltersUserSettings() {
            let userSettings = this.$store.state.authUserSettings
            // console.log('in saveAllFiltersUserSettings, this.minShafts: ' + this.minShafts)
            userSettings.MinShafts = this.minShafts
            userSettings.MaxShafts = this.maxShafts
            userSettings.MaxTreadles = this.maxTreadles
            userSettings.MaxFloatLength = this.maxFloatLength
            this.$store.commit('setFilters', userSettings)
            // console.log('user settings after update: ' + JSON.stringify(userSettings))
            this.putUserSettings(this.authUser.UserID, userSettings, this.authUser.LoginToken)
        },

        getCurrentQuerystringCopy() {
            let q = Object.assign({}, this.$route.query) // vue router won't pick up changes to the original object; a copy must be made
            if (!q.page) {
                q.page = '0'
            }
            if (!q.minshafts) {
                q.minshafts = '0'
            }
            if (!q.maxshafts) {
                q.maxshafts = '0'
            }
            if (!q.maxtreadles) {
                q.maxtreadles = '0'
            }
            if (!q.maxfloatlength) {
                q.maxfloatlength = '0'
            }
            return q
        },

        setSelectedCollectionOrCategory(newItemId) {
            let st = ''
            let p = Object.assign({}, this.$route.params) // vue router won't pick up changes to the original object; a copy must be made

            if (!newItemId) {
                newItemId = 0
            }

            let q = this.getCurrentQuerystringCopy()

            q.page = '0'

            if (this.searchType === 'collection') {
                p.searchType = 'collection'
                p.bookOrCategoryId = newItemId
                this.selectedCollectionId = newItemId
                if (newItemId > 0) {
                    st = this.sanitizeUrlSegment(this.getCurrentCollectionOption(newItemId).text)
                    p.collectionTitle = st
                }
                else {
                    p.collectionTitle = null
                }

                this.loadCollectionDescription()
            }
            else if (this.searchType === 'category') {
                p.searchType = 'category'
                p.bookOrCategoryId = newItemId
                this.selectedCategoryId = newItemId
                if (newItemId > 0) {
                    st = this.sanitizeUrlSegment(this.getCurrentCategoryOption(newItemId).text)
                    st = st.slice(0, st.indexOf('('))
                    p.collectionTitle = st
                }
                else {
                    p.collectionTitle = null
                }
            }
            this.$router.replace({ params: p, query: q }).catch(err => {})
            this.initializeComponent()
        },

        resultsVisible() {
            if (this.searchType === 'collection') {
                return (this.selectedCollectionId > 0)
            }
            if (this.searchType === 'category') {
                return (this.selectedCategoryId > 0)
            }
            if (this.searchType === 'keyword') {
                // return this.keyword.trim().length > 0
                return true
            }
            if (this.searchType === 'clipboard') {
                return this.isAuthenticated && this.patternsArray.length > 0
            }
            if (this.searchType === 'board') {
                return true
            }
            return true
        },

        initializeComponent() {
            this.itemsPerPage = cfg.config.draftResultsPerPage
            this.initialPageNum = this.$route.query.page ? Number.parseInt(this.$route.query.page) : 0

            // on the initial page load only, default filters from user settings if logged in
            if (this.initialPageLoad) {
                this.searchType = this.$route.params.searchType

                if (this.isAuthenticated) {
                    this.minShafts = this.authUserSettings.MinShafts
                    this.maxShafts = this.authUserSettings.MaxShafts
                    this.maxTreadles = this.authUserSettings.MaxTreadles
                    this.maxFloatLength = this.authUserSettings.MaxFloatLength
                }

                // on the initial page load only, allow querystring to override these values for a saved search when nonzero (non default) values are specified
                if (this.$route.query.minshafts) {
                    if (Number.parseInt(this.$route.query.minshafts) > 0) {
                        this.minShafts = Number.parseInt(this.$route.query.minshafts)
                    }
                }
                if (this.$route.query.maxshafts) {
                    if (Number.parseInt(this.$route.query.maxshafts) > 0) {
                        this.maxShafts = Number.parseInt(this.$route.query.maxshafts)
                    }
                }
                if (this.$route.query.maxtreadles) {
                    if (Number.parseInt(this.$route.query.maxtreadles) > 0) {
                        this.maxTreadles = Number.parseInt(this.$route.query.maxtreadles)
                    }
                }
                if (this.$route.query.maxfloatlength) {
                    if (Number.parseInt(this.$route.query.maxfloatlength) > 0) {
                        this.maxFloatLength = Number.parseInt(this.$route.query.maxfloatlength)
                    }
                }
                this.initialPage = false
                this.setQuerystringValue('minshafts', this.minShafts)
                this.setQuerystringValue('maxshafts', this.maxShafts)
                this.setQuerystringValue('maxtreadles', this.maxTreadles)
                this.setQuerystringValue('maxfloatlength', this.maxFloatLength)
            }

            this.patternId = this.$route.query.patternId ? Number.parseInt(this.$route.query.patternId) : 0
            this.threadingHash = this.$route.query.threadingHash ? this.$route.query.threadingHash : 0
            this.isTurned = this.$route.query.isTurned ? (Number.parseInt(this.$route.query.isTurned) === 1) : false
            this.isStraightened = this.$route.query.isStraightened ? (Number.parseInt(this.$route.query.isStraightened) === 1) : false
            this.isPointed = this.$route.query.isPointed ? (Number.parseInt(this.$route.query.isPointed) === 1) : false

            switch (this.searchType) {
                case 'collection': {
                    if (this.collectionOptions.length === 0) {
                        this.getCollectionsList().then(resp => {
                            this.collectionOptions = []

                            this.collectionOptions.push({ text: '(Select a Collection)', value: 0 })
                            for (let c=0; c < resp.data.length; c++) {
                                let collection = resp.data[c]
                                this.collectionOptions.push({ text: collection.TitleWithAuthors, value: collection.BookID })
                            }

                            this.selectedCollectionId = Number.parseInt(this.$route.params.bookOrCategoryId ? this.$route.params.bookOrCategoryId : 0)
                            if (!this.selectedCollectionId) { // can happen because the previous Angular version used "all" as a fake collection name when not specified
                                this.selectedCollectionId = 0
                            }

                            this.loadDraftsForSelectedCollection()
                            this.loadCollectionDescription()
                        })
                    }
                    else {
                        this.loadDraftsForSelectedCollection()
                        this.loadCollectionDescription()
                    }
                    break
                }

                case 'category': {
                    if (this.categoryOptions.length === 0) {
                        this.getCategoriesList().then(resp => {
                            this.categoryOptions = []

                            this.categoryOptions.push({ text: '(Select a category)', value: 0 })
                            for (let c=0; c< resp.data.length; c++) {
                                let category = resp.data[c]
                                this.categoryOptions.push({ text: category.Name + ' (' + category.DraftsCount + ' drafts)', value: category.ID })
                            }

                            this.selectedCategoryId = Number.parseInt(this.$route.params.bookOrCategoryId ? this.$route.params.bookOrCategoryId : 0)
                            if (!this.selectedCategoryId) { // can happen because the previous Angular version used "all" as a fake category name when not specified
                                this.selectedCategoryId = 0
                            }
                            this.loadDraftsForSelectedCategory()
                        })
                    }
                    else {
                        this.loadDraftsForSelectedCategory()
                    }
                    break
                }
                case 'alllikes': {
                    this.loadLikedDrafts(0)
                    break
                }
                case 'mylikes': {
                    this.loadLikedDrafts(this.authUser.UserID)
                    break
                }
                case 'alltags': {
                    let tagID = this.$route.params.bookOrCategoryId
                    let userID = 0 // all drafts associated with tags from everyone
                    this.getTag(tagID).then(resp => {
                        let tag = resp.data
                        this.tagName = tag.TagName
                        this.loadDraftsForSelectedTag(tagID, userID, tag.TagName)
                    })
                    break
                }
                case 'mytags': {
                    let tagID = this.$route.params.bookOrCategoryId
                    let userID = this.authUser.UserID // only drafts associated with tags that the current user assigned
                    this.getTag(tagID).then(resp => {
                        let tag = resp.data
                        this.tagName = tag.TagName
                        this.loadDraftsForSelectedTag(tagID, userID, tag.TagName)
                    })
                    break
                }
                case 'keyword': {
                    if (this.$route.query && this.$route.query.keyword) {
                        this.keyword = this.$route.query.keyword
                    }
                    this.loadDraftsForKeyword()
                    break
                }
                case 'popular': {
                    this.loadMostPopularDrafts()
                    break
                }
                case 'surprise': {
                    this.loadRandomDrafts()
                    break
                }
                case 'newest': {
                    this.loadNewestDrafts()
                    break
                }
                case 'clipboard': {
                    this.loadClipboardDrafts()
                    break
                }
                case 'board': {
                    this.boardId = Number.parseInt(this.$route.params.bookOrCategoryId)
                    // console.log('in DraftSearch board search, boardId: ' + this.boardId)
                    if (this.board===null || this.board.BoardID === 0) {
                        this.getUserBoard(this.boardId).then(resp => {
                            // console.log('board data returned: ' + JSON.stringify(resp.data))
                            this.board = resp.data
                            if (this.board) {
                                this.loadBoardDrafts()
                            }
                            else {
                                this.boardNotFound = true
                            }
                        })
                    }
                    else {
                        this.loadBoardDrafts()
                    }
                    break
                }
                case 'threading': {
                    this.thumbnailSize = this.getThumbnailDisplaySize()
                    if (this.patternId > 0) {
                        this.getPattern(this.patternId).then((resp) => {
                            this.searchPrompt = 'Drafts Matching Threading'
                            this.draftDetailUrl = this.buildDraftDetailUrl(resp.data)
                            if (this.isTurned && this.isStraightened) {
                                this.threadingSearchSubPrompt = ' turned and straightened'
                            }
                            else if (this.isTurned && this.isPointed) {
                                this.threadingSearchSubPrompt = ', turned and point threaded'
                            }
                            else if (this.isTurned) {
                                this.threadingSearchSubPrompt = ', turned'
                            }
                            else if (this.isStraightened) {
                                this.threadingSearchSubPrompt = ', straightened'
                            }
                            else if (this.isPointed) {
                                this.threadingSearchSubPrompt = ', point threaded'
                            }
                            if (this.isSubscriber) {
                                this.loadDraftJSONForThreadingDisplay()
                            }
                        })
                    }
                    else {
                        if (this.threadingSearchJSON) {
                            this.loadDraftJSONToArraysForDisplay(this.threadingSearchJSON)
                        }
                    }
                    this.loadMatchingThreadingDrafts()
                    break
                }
            }
        },

        loadCollectionDescription() {
            this.getCollection(this.selectedCollectionId).then(resp => {
                this.collectionDescription = resp.data.Description
                this.collectionOriginalSourceLinkUrl = resp.data.OriginalSourceLinkUrl
                this.collectionOriginalSourceLinkText = resp.data.OriginalSourceLinkText
            })
        },

        loadDraftsForSelectedCategory() {
            this.searchPrompt = 'Drafts from Category: '
            this.searchPrompt += (this.selectedCategoryId > 0) ? this.getCurrentCategoryOption(this.selectedCategoryId).text : 'All Categories'
            let startingResult = this.calculateCurrentStartingResult()

            if (this.selectedCategoryId > 0) {
                this.getMatchingPatterns(0, 0, this.keyword, this.selectedCategoryId, '', this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                })
            }
            else {
                this.totalResults = 0
                this.patternsArray = []
            }
        },

        loadDraftsForSelectedTag(tagID, userID) {
            // console.log('in loadDratsForSelectedTag, tagID: ' + tagID + ' userID: ' + userID)
            let startingResult = this.calculateCurrentStartingResult()
            this.getMatchingPatterns(userID, 0, this.keyword, '', tagID, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadDraftsForSelectedCollection() {
            this.searchPrompt = 'Drafts from: '
            this.searchPrompt += (this.selectedCollectionId > 0) ? this.getCurrentCollectionOption(this.selectedCollectionId).text : 'All Collections'
            let startingResult = this.calculateCurrentStartingResult()

            // console.log('in loadDraftsForSelectedCollection, minShafts: ' + this.minShafts)

            if (this.selectedCollectionId > 0) {
                this.getMatchingPatterns(0, this.selectedCollectionId, this.keyword, '', '', this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                })
            }
            else {
                this.totalResults = 0
                this.patternsArray = []
            }
        },

        loadLikedDrafts(userID) {
            // console.log('in loadLikedDrafts, userID: ' + userID)
            if (this.isAuthenticated || this.searchType==='alllikes') {
                let startingResult = this.calculateCurrentStartingResult()
                this.getLikedPatterns(userID, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                })
            }
        },

        debounceKeywordInput() {
            this.debounceInput(function() {
                this.loadDraftsForKeyword()
            }, 1000)
        },

        loadDraftsForKeyword() {
            // searchPrompt isn't shown for keyword
            let startingResult = this.calculateCurrentStartingResult()
            this.getMatchingPatterns(0, 0, this.keyword, '', '', this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadMostPopularDrafts() {
            this.searchPrompt = 'Most Popular Drafts'
            let startingResult = this.calculateCurrentStartingResult()
            this.getMostPopularPatterns(cfg.config.mostPopularResultsCount, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadRandomDrafts() {
            this.totalResults = 0
            this.patternsArray = []
            this.searchPrompt = 'Randomly Chosen Drafts'

            let randResultsCount = cfg.config.randomResultsCount
            let randWarpThreadCount = cfg.config.randomMaxWarpThreadsCount
            let randWeftThreadCount = cfg.config.randomMaxWarpThreadsCount

            this.getRandomPatterns(randResultsCount, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, randWarpThreadCount, randWeftThreadCount).then(resp => {
                this.totalResults = cfg.config.randomResultsCount
                this.patternsArray = resp.data
            })
        },

        loadNewestDrafts() {
            this.searchPrompt = 'Newest Drafts'
            let startingResult = this.calculateCurrentStartingResult()
            this.getNewestPatterns(cfg.config.newestResultsCount, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadMatchingThreadingDrafts() {
            let startingResult = this.calculateCurrentStartingResult()
            this.getMatchingThreadingPatterns(this.patternId, this.threadingHash, this.isTurned, this.isStraightened, this.isPointed, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadClipboardDrafts() {
            let startingResult = this.calculateCurrentStartingResult()
            if (this.isAuthenticated) {
                this.getClipboardPatterns(this.authUser.UserID, this.itemsPerPage, startingResult).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                    this.searchPrompt = 'Your Draft Clipboard'
                    if (this.patternsArray.length === 0) {
                        this.searchPrompt = '(Your Draft Clipboard is Empty)'
                    }
                })
            }
        },

        loadBoard(boardID) {
            this.getUserBoard(this.boardId).then(resp => {
                this.board = resp.data
            })
        },

        loadBoardDrafts() {
            let startingResult = this.calculateCurrentStartingResult()
            if (this.board != null) {
                this.getUserBoardPatterns(this.boardId, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, this.itemsPerPage, startingResult).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                    // console.log('board: ' + JSON.stringify(this.board))
                    this.searchPrompt = this.board.Title + ', board by ' + this.board.OwnerName
                })
            }
        },

        handleClearBoard() {
            if (this.isAuthenticated) {
                if (this.searchType==='clipboard') {
                    this.clearClipboard(this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                        this.showClearBoardDialog(false)
                        this.initializeComponent()
                    })
                }
                else if (this.searchType==='board') {
                    if (this.userIsBoardOwner) {
                        this.deleteUserBoardPatterns(this.board.BoardID, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                            this.showClearBoardDialog(false)
                            this.initializeComponent()
                        })
                    }
                }
            }
        },

        showClearBoardDialog(isShow) {
            isShow ? this.$refs.boardClearModalRef.show() : this.$refs.boardClearModalRef.hide()
        },

        handleClearBoardCancel() {
            this.showClearBoardDialog(false)
        },

        calculateCurrentStartingResult() {
            return (this.initialPageNum * this.itemsPerPage) + 1 // paged pattern functions expect a startingResult that is 1-based, but maintained in Vue component state as 0-based
        },

        setThumbnailsSize() {
        },

        loadDraftJSONForThreadingDisplay() {
            this.getPatternJson(this.patternId, this.isStraightened, false, this.isPointed, false, this.isTurned, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadDraftJSONToArraysForDisplay(resp.data)
            })
        },

        loadDraftJSONToArraysForDisplay(draftJSON) {
            this.sampleDraft = draftJSON
            // load threading
            this.threading = new Array(this.sampleDraft.ShaftsCount)
            this.loadThreadingArrayFromDraftJSON(this.threading, this.sampleDraft)
        },

        getThumbnailDisplaySize() {
            if (this.isAuthenticated) {
                console.log('in thumbnailDisplaySize authenticated, returning: ' + this.$store.state.authUserSettings.ThumbnailSize)
                return this.$store.state.authUserSettings.ThumbnailSize
            }
            console.log('in thumbnailDisplaySize nonauthenticated, returning: 1')
            return 1
        },

        onThumbnailSizeChanged(evt) {
            console.log('in onThumbnailSizeChanged, evt: ' + JSON.stringify(evt))
            this.thumbnailSize = evt.size
        },

        getTableCellStyles(includeRightPadding, includeBottomPadding) {
            let tdStyle = ''
            if (includeRightPadding) {
                tdStyle += 'padding-right: ' + this.cellPixelSize + 'px;'
            }
            if (includeBottomPadding) {
                tdStyle += 'padding-bottom: ' + this.cellPixelSize + 'px;'
            }
            return tdStyle
        },

        generateNumbersArray(min, max) {
            let a = []
            for (let k=min; k<=max; k++) {
                a.push(k)
            }
            return a
        }
    },

    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        draftSearchResults: draftSearchResults,
        relatedStoreProducts: relatedStoreProducts,
        loginControl: loginControl,
        grid: grid,
        ruler: ruler
    },

    watch: {
        'authUser.UserID': function(val) {
            this.initializeComponent()
        },
        '$route.params.searchType': function(val) {
            this.initializeComponent()
        }
    },

    computed: {
        authUser: function() {
            return this.$store.state.authUser
        },
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },
        authUserSettings: function() {
            return this.$store.state.authUserSettings
        },
        threadingSearchJSON: function() {
            return this.$store.state.threadingSearchJSON
        },
        minShaftsOptions: function() {
            return this.generateNumericOptionsList('(Any)', 0, this.generateNumbersArray(1, 80))
        },
        maxShaftsOptions: function() {
            return this.generateNumericOptionsList('(Any)', 0, this.generateNumbersArray(1, 80))
        },
        maxTreadlesOptions: function() {
            return this.generateNumericOptionsList('(Any)', 0, this.generateNumbersArray(1, 80))
        },
        maxFloatLengthOptions: function() {
            return this.generateNumericOptionsList('(Any)', 0, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20])
        },
        userIsBoardOwner: function() {
            return (this.isAuthenticated && ((this.searchType==='board' && this.board && this.authUser.UserID === this.board.UserID) || (this.searchType === 'clipboard')))
        },
        cellPixelSize: function() {
            return this.thumbnailSize + 5
        }
    },
    created() {
        this.$store.commit('setPageTitle', 'Weaving Drafts Search')
        let initialPage = this.$route.query.page
        if (!initialPage) {
            initialPage = 0
        }
        this.goToPage(initialPage) // this will add any missing querystring parameters with default values
    }
}
</script>

<style scoped>
    .bold-prompt {
        font-weight: bold;
    }
    .input-larger-text {
        font-size: 1.75rem;
    }

    td {
        padding: 0;
        margin: 0;
        border: none;
        border-spacing: 0;
        border-collapse: collapse;
        line-height: 1px;
    }

    tr {
        padding: 0;
        margin: 0;
        border-spacing: 0;
    }    

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    .prevent-scrolling-on-touch {
        touch-action: none
    }

</style>


// WEBPACK FOOTER //
// src/components/DraftSearch.vue